import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import logo from './assets/images/logo.png';
import background from './assets/images/crescimento-de-vendas.png';
import logo2 from './assets/images/logo2.png';
import arrow from './assets/images/seta.png';
import bag from './assets/images/bag.png';
import box from './assets/images/box.png';
import cloud from './assets/images/cloud.png';
import sound from './assets/images/tradicao.jpg';
import cpu from './assets/images/Cpu.png';
import clock from './assets/images/Clock.png';
import mic from './assets/images/Mic.png';
import settings from './assets/images/Settings.png';
import radio from './assets/images/radio-indoor.jpg';
import espera_telefonica from './assets/images/espera-telefonica.jpg';
import tv_corporativa from './assets/images/tv-institucional.png';
import music_branding from './assets/images/music-branding.jpg';
import logo_parceiro1 from './assets/images/logo-parceiro1.png';
import logo_parceiro2 from './assets/images/logo-parceiro2.png';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const images = {
  logo,
  background,
  logo2,
  arrow,
  bag,
  box,
  cloud,
  sound,
  cpu,
  clock,
  mic,
  settings,
  radio,
  espera_telefonica,
  tv_corporativa,
  music_branding,
  logo_parceiro1,
  logo_parceiro2
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export default images;